import { Modal, Typography } from "antd";
import { Socket } from "socket.io-client";
import { useState } from "react";

import { ReactComponent as CloseIcon } from "../../../common/images/svg/CloseIcon.svg";
import { ReactComponent as PrinterIcon } from "../../../common/images/svg/Printer.svg";
import useResponsive from "../../../utils/hooks/useResponsive";
import FormWithdrawSuccess from "./form-withdraw-success";

interface ModalSuccessProps {
  openModalSuccess: boolean;
  setOpenModalSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  responseWithdrawal: any;
  setResponseWithdrawal: React.Dispatch<any>;
  socket: Socket<any, any>;
}

const ModalSuccess = ({
  openModalSuccess,
  setOpenModalSuccess,
  responseWithdrawal,
  setResponseWithdrawal,
  socket,
}: ModalSuccessProps) => {
  const { isTablet } = useResponsive();
  const [printableFormUrl, setPrintableFormUrl] = useState<string | null>(null);

  const handleCancel = () => {
    setOpenModalSuccess(false);
    setResponseWithdrawal(null);
    setPrintableFormUrl(null);
  };

  return (
    <Modal
      open={!!openModalSuccess}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      maskClosable={false}
      title={
        <>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <Typography
              style={{
                fontSize: isTablet ? 16 : 20,
                fontWeight: 700,
                color: "#C2C6CE",
              }}
            >
              {`Order Created Successfully`}
            </Typography>
            {printableFormUrl && (
              <PrinterIcon
                className="icon-animation"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(printableFormUrl, "_blank")
                }
              />
            )}
          </div>
          <CloseIcon onClick={handleCancel} className="icon-animation" />
        </>
      }
      className="send-money-modal"
    >
      <FormWithdrawSuccess
        responseWithdrawal={responseWithdrawal}
        socket={socket}
        setPrintableFormUrl={setPrintableFormUrl}
      />
    </Modal>
  );
};

export default ModalSuccess;
